export const Empresas = {
  JALEKO: 1
}

export default Empresas
